import {GameType} from "./gameType";
import {Team} from "./team";
import {GameStatus} from "./gameStatus";

export interface GameInfo {
  awayScore:	number
  awayTeam: Team

  gameStatus:	string
  gameDate:	string // Date
  gameTime:	string // Date

  homeScore: number
  homeTeam: Team

  id: string
  rseqNumber:	number

  numberOfDowns: number
  gameType: GameType
  seasonId: string
}

export const gameDemo: GameInfo = {
  "id": "Démo",
  "rseqNumber": 0,

  "gameDate": "2050-09-02T00:00:00.000Z",
  "gameTime": "20:00:00",
  "homeScore": 0,
  "awayScore": 0,
  "gameStatus": GameStatus.InProgress,
  "awayTeam": {
    "id": "2",
    "teamName": "Les Escargots enflamées",
    "teamLogo": "demo.png",
    "teamShortName": "Escargots",
    "teamNameAbr": "Esc",
    "teamLeague": {
      id: "demo",
      name: "demo",
      shortName: "demo"
    },
    teamLogoUrl: "https://i.imgur.com/Kjevqsf.png",
    isPayingTeam: true
  },
  "homeTeam": {
    "id": "1",
    "teamName": "Les Pintades enragées",
    "teamLogo": "demo.png",
    "teamShortName": "Pintades",
    "teamNameAbr": "Pin",
    "teamLeague": {
      id: "demo",
      name: "demo",
      shortName: "demo"
    },
    teamLogoUrl: "https://i.imgur.com/Kjevqsf.png",
    isPayingTeam: true
  },

  "numberOfDowns": 4,
  "gameType": GameType.Season,
  seasonId: "season demo"
};
